/// <amd-module name="DistributedTask/Common/Library/Sources/AgentSpecificationService" />
import { TaskAgentQueue } from "DistributedTask/Client/Contracts/TaskAgent";
import * as Resources from "DistributedTask/Common/Library/Resources";
import { IReadonlyObservableArray, IObservableValue, ObservableArray, ObservableValue } from "VSS/Core/Observable";
import { Services, IVssPageContext, IVssService, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

export interface IAgentSpecification {
    identifier: string;
}

export interface IAgentSpecificationService extends IVssService {
    getAgentSpecificationsByQueue(queue: TaskAgentQueue): Promise<IAgentSpecification[]>;
}

// delete after M152
export interface IAgentSpecificationObservableValues {
    agentSpecifications: IReadonlyObservableArray<IAgentSpecification>;
    errorMessage: IObservableValue<string>;
}

export class AgentSpecificationService extends VssService implements IAgentSpecificationService {
    private _agentSpecifications: ObservableArray<IAgentSpecification>;
    private _lastServiceError: ObservableValue<string>;
    public static readonly AZURE_PIPELINES = "Azure Pipelines";

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);
        this._agentSpecifications = new ObservableArray();
        this._lastServiceError = new ObservableValue<string>("");

    }

    public async getAgentSpecificationsByQueue(queue: TaskAgentQueue): Promise<IAgentSpecification[]> {
        if (!isFeatureFlagEnabled(this.pageContext, "WebAccess.Build.CIWorkflow.AgentDefinition", false)) {
            return Promise.resolve([]);
        }

        if (!queue || !queue.pool || !queue.pool.isHosted || queue.pool.name !== AgentSpecificationService.AZURE_PIPELINES) {
            return Promise.resolve([]);
        }

        const dataProviderId = "ms.vss-build-web.agent-definitions-data-provider";
        const requestParams = {
            queueId: queue.id,
        };

        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");

        const ignoreCache = true;
        return contributionService.getDataAsync<IAgentSpecification[]>(dataProviderId, requestParams, ignoreCache)
            .then(agentSpecifications => agentSpecifications ? agentSpecifications : []);
    }
}

Services.add("IAgentSpecificationService", { serviceFactory: AgentSpecificationService });
